export const layerAccessGrantsKeys = {
  prefix: 'layerAccessGrants',
  list: (layerId: string, { password }: { password?: string | null }) => [
    layerAccessGrantsKeys.prefix,
    layerId,
    'list',
    { password },
  ],
  revokeAll: (layerId: string, password?: string | null) => [
    ...layerAccessGrantsKeys.list(layerId, { password }),
    'revokeAll',
  ],
  revoke: (id: number) => [layerAccessGrantsKeys.prefix, id, 'revoke'],
}
